import * as IF from "infrontjs";
import template from './template.html';

class RoutineCheckItem extends HTMLElement
{
    static get observedAttributes()
    {
        return [ 'weekly-count' ];
    }

    get weeklyFrequence()
    {
        let ret = this.getAttribute( 'weekly-frequence' );
        if ( ret )
        {
            return ret;
        }
        else
        {
            return 0;
        }
    }

    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.render();

            this.root.addEventListener( 'click', () =>
            {
                if ( this.querySelector( '.routine-check' ).classList.contains( 'loading' ) )
                {
                    return false;
                }
                else if ( this.querySelector( '.routine-check' ).classList.contains( 'checked' ) )
                {
                    const logEvent = new CustomEvent(
                        'unlogActivity',
                        {
                            detail :
                                {
                                    uuid : this.getAttribute( 'uuid' )
                                }
                        }
                    );
                    this.dispatchEvent( logEvent );
                    return true;
                }
                else
                {
                    const logEvent = new CustomEvent(
                        'logActivity',
                        {
                            detail :
                                {
                                    uuid : this.getAttribute( 'uuid' )
                                }
                        }
                    );
                    this.dispatchEvent( logEvent );
                    return true;
                }
            });

            this._isConnected = true;
        }
    }

    setLoadingState()
    {
        this.querySelector( '.routine-check' ).classList.add( 'loading' );
    }

    removeLoadingState()
    {
        this.querySelector( '.routine-check' ).classList.remove( 'loading' );
    }

    markChecked()
    {
        this.querySelector( '.routine-check' ).classList.replace( 'loading','checked' );
        if ( 'weekly' === this.getAttribute( 'goal' ) )
        {
            this.setAttribute(
                'weekly-count',
                parseInt( this.getAttribute( 'weekly-count' ) ) + 1
            );
        }
    }

    unmarkChecked()
    {
        this.querySelector( '.routine-check' ).classList.remove( 'checked' );
        if ( 'weekly' === this.getAttribute( 'goal' ) )
        {
            this.setAttribute(
                'weekly-count',
                parseInt( this.getAttribute( 'weekly-count' ) ) - 1
            );
        }
    }

    attributeChangedCallback( name, oldVal, newVal )
    {
        if ( true === this._isConnected )
        {
            if ( name === 'weekly-count' )
            {
                const percentage = ( parseInt( this.getAttribute( 'weekly-count' ) ) / parseInt( this.getAttribute( 'weekly-frequence' ) ) ) * 100;
                this.querySelector('[data-id="progress-bar"]' ).style.width = percentage + '%';

                if ( percentage >= 99 )
                {
                    this.querySelector( '.routine-name' ).classList.add( 'routine-name-tocross' );
                }
            }
        }
    }

    disconnectedCallback()
    {
        this.root.removeEventListeners( 'click' );
    }

    render()
    {
        const goal = this.hasAttribute( 'goal' ) ? this.getAttribute( 'goal' ) : 'daily';
        let percentage = 0,
            isChecked = false;
        if ( 'weekly' === goal )
        {
            percentage = ( parseInt( this.getAttribute( 'weekly-count' ) ) / parseInt( this.getAttribute( 'weekly-frequence' ) ) ) * 100;

            // @todo Check if isChecked
            isChecked = this.hasAttribute( 'is-checked' ) ? true : false;
        }

        this.root.innerHTML = this.app.view.getHtml(
            template,
            {
                name : this.getAttribute( 'name' ),
                icon : this.getAttribute( 'icon' ),
                goal : goal,
                percentage : percentage,
                isChecked : isChecked
            }
        );
    }

}

customElements.define('routine-check-item', RoutineCheckItem );
